import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

@Component({
  selector: 'iw-title',
  imports: [],
  templateUrl: './title.component.html',
  styleUrl: './title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.clickable]': 'clickable()',
  },
})
export class TitleComponent {
  readonly title = input<string>();
  readonly clickable = input(false, { transform: booleanAttribute });

  readonly clicked = output<void>();
}
